import { UNAUTHORIZED_APP_ROUTES } from '../constants/routes';

export const isUnauthorizedRoute = () => UNAUTHORIZED_APP_ROUTES.includes(window.location.pathname);

export const renderPdf = (pdf) => {
  window.location.href = pdf;
  return null;
};
